import {builderX} from '@gongxigames/framework/core/fragments/BuilderX';
import loader from './loader';
import symbols from './symbols';
import reels from './reels';
import newReels from './newReels';
import paytableAssets from './paytableAssets';
import numbers from './numbers';
import ImagesForAdvancedText from './ImagesForAdvancedText';
import bonus from './bonus';
import background_desktop from './desktop/background';
import background_mobile from './mobile/background';

builderX.register('loader', loader);
builderX.register('symbols', symbols);
builderX.register('reels', reels);
builderX.register('newReels', newReels);
builderX.register('paytableAssets', paytableAssets);
builderX.register('numbers', numbers);
builderX.register('ImagesForAdvancedText', ImagesForAdvancedText);
builderX.register('bonus', bonus);
builderX.register('background', background_desktop, 'desktop');
builderX.register('background', background_mobile, 'mobile');
